export const GET_FAQ="GET_FAQ"
export const ADD_FAQ="ADD_FAQ"
export const EDIT_FAQ="EDIT_FAQ"
export const DELETE_FAQ="DELETE_FAQ"
